import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { getDiscountPrice } from "../../../helpers/product";
import { addToCart, decrementQty, removeFromCart, removeAllFromCart } from "../../../redux/actions/cartActions";
import { constructArtificialLinkNode, getDynamicLink, getStaticPageLink } from "../../../utils/links";
import Breadcrumb from "../../../components/magnolia/breadcrumb/Breadcrumb";
import Image from "../../../components/magnolia/image/Image";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";
import LinkWrapper from "../../../components/magnolia/linkWrapper/LinkWrapper";
import CountrySelect from "../../../components/magnolia/countrySelect/CountrySelect";
import { decodeText } from "../../../utils/richText";
import { getChildNodes } from "../../../utils/nodes";

// Stock of a cart line in the Magnolia product shape: variant products carry it on the selected
// colour's size node, plain products on the product itself. Unknown stock never blocks "+".
const cartItemStock = (item) => {
    const variation = item.variation;
    if (variation && variation["@nodes"]) {
        const colour = getChildNodes(variation).find((v) => v.color === item.selectedProductColor);
        const size = getChildNodes(colour?.size).find((candidate) => candidate.name === item.selectedProductSize);
        if (size && typeof size.stock === "number") return size.stock;
    }
    return typeof item.stock === "number" ? item.stock : Infinity;
};

const Cart = ({ location, cartItems, currency, decrementQty, addToCart, removeFromCart, removeAllFromCart }) => {
    let cartTotalPrice = 0;

    return (
        <Fragment>
            <HtmlHeader title="Cart" />
            <Breadcrumb />

            <div className="cart-main-area pt-90 pb-100">
                <div className="container">
                    {cartItems && cartItems.length >= 1 ? (
                        <Fragment>
                            <h3 className="cart-page-title">Your cart items</h3>
                            <div className="row">
                                <div className="col-12">
                                    <div className="table-content table-responsive cart-table-content">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Image</th>
                                                    <th>Product Name</th>
                                                    <th>Unit Price</th>
                                                    <th>Qty</th>
                                                    <th>Subtotal</th>
                                                    <th>action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cartItems.map((cartItem, key) => {
                                                    const discountedPrice = getDiscountPrice(cartItem.price, cartItem.discount);
                                                    const finalProductPrice = (cartItem.price * currency.currencyRate).toFixed(2);
                                                    const finalDiscountedPrice = (discountedPrice * currency.currencyRate).toFixed(2);

                                                    const productLinkNode = constructArtificialLinkNode({
                                                        value: getDynamicLink("PRODUCT_DETAIL", cartItem["@name"]),
                                                    });

                                                    discountedPrice != null
                                                        ? (cartTotalPrice += finalDiscountedPrice * cartItem.quantity)
                                                        : (cartTotalPrice += finalProductPrice * cartItem.quantity);
                                                    return (
                                                        <tr key={key}>
                                                            <td className="product-thumbnail">
                                                                {cartItem.image && cartItem.image[0] && (
                                                                    <LinkWrapper linkNode={productLinkNode}>
                                                                        <Image imageNode={cartItem.image[0]} className="img-fluid" />
                                                                    </LinkWrapper>
                                                                )}
                                                            </td>

                                                            <td className="product-name">
                                                                <LinkWrapper linkNode={productLinkNode}>{decodeText(cartItem.displayName)}</LinkWrapper>

                                                                {cartItem.selectedProductColor && cartItem.selectedProductSize ? (
                                                                    <div className="cart-item-variation">
                                                                        <span>Color: {cartItem.selectedProductColor}</span>
                                                                        <span>Size: {cartItem.selectedProductSize}</span>
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>

                                                            <td className="product-price-cart">
                                                                {discountedPrice !== null ? (
                                                                    <Fragment>
                                                                        <span className="amount old">
                                                                            {currency.currencySymbol + finalProductPrice}
                                                                        </span>
                                                                        <span className="amount discounted">
                                                                            {currency.currencySymbol + finalDiscountedPrice}
                                                                        </span>
                                                                    </Fragment>
                                                                ) : (
                                                                    <span className="amount">
                                                                        {currency.currencySymbol + finalProductPrice}
                                                                    </span>
                                                                )}
                                                            </td>

                                                            <td className="product-quantity">
                                                                <div className="cart-plus-minus">
                                                                    <button
                                                                        className="dec qtybutton"
                                                                        onClick={() => decrementQty(cartItem)}
                                                                    >
                                                                        -
                                                                    </button>
                                                                    <input
                                                                        className="cart-plus-minus-box"
                                                                        type="text"
                                                                        value={cartItem.quantity}
                                                                        readOnly
                                                                    />
                                                                    <button
                                                                        className="inc qtybutton"
                                                                        onClick={() =>
                                                                            addToCart(cartItem, 1, cartItem.selectedProductColor, cartItem.selectedProductSize)
                                                                        }
                                                                        disabled={cartItem.quantity >= cartItemStock(cartItem)}
                                                                    >
                                                                        +
                                                                    </button>
                                                                </div>
                                                            </td>
                                                            <td className="product-subtotal">
                                                                {discountedPrice !== null
                                                                    ? currency.currencySymbol +
                                                                      (finalDiscountedPrice * cartItem.quantity).toFixed(2)
                                                                    : currency.currencySymbol +
                                                                      (finalProductPrice * cartItem.quantity).toFixed(2)}
                                                            </td>

                                                            <td className="product-remove">
                                                                <button onClick={() => removeFromCart(cartItem)}>
                                                                    <i className="fa fa-times"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="cart-shiping-update-wrapper">
                                        <div className="cart-shiping-update">
                                            <LinkWrapper linkNode={constructArtificialLinkNode({ value: getStaticPageLink("HOME") })}>
                                                Continue Shopping
                                            </LinkWrapper>
                                        </div>
                                        <div className="cart-clear">
                                            <button onClick={() => removeAllFromCart()}>Clear Shopping Cart</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <div className="cart-tax">
                                        <div className="title-wrap">
                                            <h4 className="cart-bottom-title section-bg-gray">Estimate Shipping And Tax</h4>
                                        </div>
                                        <div className="tax-wrapper">
                                            <p>Enter your destination to get a shipping estimate.</p>
                                            <div className="tax-select-wrapper">
                                                <div className="tax-select">
                                                    <label>* Country</label>
                                                    <CountrySelect className="email s-email s-wid" />
                                                </div>
                                                <div className="tax-select">
                                                    <label>* Zip/Postal Code</label>
                                                    <input type="text" />
                                                </div>
                                                <button className="cart-btn-2" type="submit">
                                                    Get A Quote
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6">
                                    <div className="discount-code-wrapper">
                                        <div className="title-wrap">
                                            <h4 className="cart-bottom-title section-bg-gray">Use Coupon Code</h4>
                                        </div>
                                        <div className="discount-code">
                                            <p>Enter your coupon code if you have one.</p>
                                            <form>
                                                <input type="text" required name="name" />
                                                <button className="cart-btn-2" type="submit">
                                                    Apply Coupon
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-12">
                                    <div className="grand-totall">
                                        <div className="title-wrap">
                                            <h4 className="cart-bottom-title section-bg-gary-cart">Cart Total</h4>
                                        </div>
                                        <h5>
                                            Total products <span>{currency.currencySymbol + cartTotalPrice.toFixed(2)}</span>
                                        </h5>

                                        <h4 className="grand-totall-title">
                                            Grand Total <span>{currency.currencySymbol + cartTotalPrice.toFixed(2)}</span>
                                        </h4>
                                        <LinkWrapper linkNode={constructArtificialLinkNode({ value: getStaticPageLink("CHECKOUT") })}>
                                            Proceed to Checkout
                                        </LinkWrapper>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="item-empty-area text-center">
                                    <div className="item-empty-area__icon mb-30">
                                        <i className="pe-7s-cart"></i>
                                    </div>
                                    <div className="item-empty-area__text">
                                        No items found in cart <br />{" "}
                                        <LinkWrapper linkNode={constructArtificialLinkNode({ value: getStaticPageLink("HOME") })}>
                                            Shop Now
                                        </LinkWrapper>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

Cart.propTypes = {
    addToCart: PropTypes.func,
    cartItems: PropTypes.array,
    currency: PropTypes.object,
    decrementQty: PropTypes.func,
    location: PropTypes.object,
    removeAllFromCart: PropTypes.func,
    removeFromCart: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        cartItems: state.cartData,
        currency: state.currencyData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (item, quantityCount, selectedProductColor, selectedProductSize) => {
            dispatch(addToCart(item, quantityCount, selectedProductColor, selectedProductSize));
        },
        decrementQty: (item) => {
            dispatch(decrementQty(item));
        },
        removeFromCart: (item) => {
            dispatch(removeFromCart(item));
        },
        removeAllFromCart: () => {
            dispatch(removeAllFromCart());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
